let elements = {
  /**direction type:
  auto
  top
  bottom
  left
  right
  topleft
  topright
  bottomleft
  bottomright
  lefttop
  leftbottom
  righttop
  rightbottom
  **/

  mainImage: {
    imagePath: 'games/page034_game10/img/bcg.jpg',
    width: 1030,
    height: 910,
    pos: {
      x: 559,
      y: 138,
    },
  },
  activeArea: {
    width: 40,
    height: 40,
    fontSize: 28,
    backgroundColor: '#f36f1a',
    color: '#ffffff',
  },
  items: [
    {
      id: '1',
      animation: true,
      // direction: 'left',
      textObj: {
        text: 'Sposób 1. Kliknij dwukrotnie w ikonę skrótu do programu Paint 3D na <i>Pulpicie</i>.	',
      },
      audio: {
        src: 'games/page034_game10/audio/z17s34s1a.mp3',
        //icon: {
        // audioOn: 'assets/on.png',
        // audioOff: 'assets/off.png',
        //},
        // position: 'top',
      },
      pos: {
        x: 634,
        y: 237,
      },
    },
    {
      id: '1',
      animation: true,
      // direction: 'left',
      textObj: {
        text: 'Sposób 2. Kliknij w ikonę programu Paint 3D na dolnym <i>Pasku zadań</i>. 	',
      },
      audio: {
        src: 'games/page034_game10/audio/z17s34s1b.mp3',
        //icon: {
        // audioOn: 'assets/on.png',
        // audioOff: 'assets/off.png',
        //},
        // position: 'top',
      },
      pos: {
        x: 800,
        y: 388,
      },
    },
    {
      id: '2',
      // direction: 'left',
      textObj: {
        text: 'Wybierz opcję <i>Nowy.</i>',
      },
      audio: {
        src: 'games/page034_game10/audio/z17s34-2.mp3',
        //icon: {
        // audioOn: 'assets/on.png',
        // audioOff: 'assets/off.png',
        //},
        // position: 'top',
      },
      pos: {
        x: 820,
        y: 664,
      },
    },
    {
      id: '3',
      direction: 'left',
      textObj: {
        text: 'Kliknij w przycisk <i>Kształty 3D</i>.',
      },
      audio: {
        src: 'games/page034_game10/audio/z17s34-3.mp3',
        //icon: {
        // audioOn: 'assets/on.png',
        // audioOff: 'assets/off.png',
        //},
        // position: 'top',
      },
      pos: {
        x: 816,
        y: 827,
      },
    },
    {
      id: '4',
      // direction: 'left',
      textObj: {
        text: 'Przesuń suwak w dół. ',
      },
      audio: {
        src: 'games/page034_game10/audio/z17s34-4.mp3',
        //icon: {
        // audioOn: 'assets/on.png',
        // audioOff: 'assets/off.png',
        //},
        // position: 'top',
      },
      pos: {
        x: 1296,
        y: 895,
      },
    },
    {
      id: '5',
      // direction: 'left',
      textObj: {
        text: 'W polu <i>Obiekty 3D</.> kliknij w przycisk <br/>z kostką.',
      },
      audio: {
        src: 'games/page034_game10/audio/z17s34-5.mp3',
        //icon: {
        // audioOn: 'assets/on.png',
        // audioOff: 'assets/off.png',
        //},
        // position: 'top',
      },
      pos: {
        x: 1092,
        y: 867,
      },
    },
    {
      id: '6',
      direction: 'left',
      textObj: {
        text: 'Kliknij w obszar rysowania.',
      },
      audio: {
        src: 'games/page034_game10/audio/z17s34-6.mp3',
        //icon: {
        // audioOn: 'assets/on.png',
        // audioOff: 'assets/off.png',
        //},
        // position: 'top',
      },
      pos: {
        x: 898,
        y: 912,
      },
    },
  ],
};
export default elements;
